import React from 'react';
import { StarIcon } from 'lucide-react';
const Reviews = () => {
  const reviews = [{
    id: 1,
    name: 'Katrin M.',
    rating: 5,
    text: 'Suurepärane teenus! Köögimööbli paigaldus oli kiire ja professionaalne. Soovitan kindlasti kõigile, kes otsivad kvaliteetset mööblipaigaldust.',
    date: '15.03.2023'
  }, {
    id: 2,
    name: 'Andres K.',
    rating: 5,
    text: 'Tellisime garderoobikapi paigalduse. Töö tehti väga korrektselt ja täpselt. Jäime tulemusega väga rahule ja kasutame nende teenuseid kindlasti ka tulevikus.',
    date: '27.04.2023'
  }, {
    id: 3,
    name: 'Marju T.',
    rating: 4,
    text: 'Kiire ja sõbralik teenindus. IKEA mööbli kokkupanek ja paigaldus sujus probleemideta. Soovitan soojalt!',
    date: '08.06.2023'
  }];
  // Function to render stars based on rating
  const renderStars = rating => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(<StarIcon key={i} size={18} className={i < rating ? 'text-yellow-500 fill-yellow-500' : 'text-gray-300'} data-id="element-307" />);
    }
    return stars;
  };
  return <section className="py-12 bg-white" data-id="element-308">
      <div className="container mx-auto px-4" data-id="element-309">
        <h2 className="text-3xl font-bold text-center mb-3 text-gray-900" data-id="element-310">
          Klientide tagasiside
        </h2>
        <p className="text-center text-gray-600 mb-10" data-id="element-311">
          Mida meie kliendid meie teenustest arvavad
        </p>
        <div className="flex justify-center mb-8" data-id="element-312">
          <div className="bg-blue-900 text-white py-3 px-6 rounded-lg flex items-center" data-id="element-313">
            <div className="text-3xl font-bold mr-3" data-id="element-314">4.8</div>
            <div data-id="element-315">
              <div className="flex" data-id="element-316">{renderStars(5)}</div>
              <div className="text-sm mt-1" data-id="element-317">Keskmine hinne 36 arvustusest</div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-318">
          {reviews.map(review => <div key={review.id} className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition duration-300" data-id="element-319">
              <div className="flex justify-between items-start mb-4" data-id="element-320">
                <div data-id="element-321">
                  <h3 className="font-semibold text-gray-900" data-id="element-322">{review.name}</h3>
                  <div className="flex mt-1" data-id="element-323">{renderStars(review.rating)}</div>
                </div>
                <span className="text-sm text-gray-500" data-id="element-324">{review.date}</span>
              </div>
              <p className="text-gray-700" data-id="element-325">{review.text}</p>
            </div>)}
        </div>
        <div className="text-center mt-8" data-id="element-326">
          <button className="border border-blue-900 text-blue-900 py-2 px-6 rounded-md hover:bg-blue-900 hover:text-white transition duration-300" data-id="element-327">
            Vaata kõiki arvustusi
          </button>
        </div>
      </div>
    </section>;
};
export default Reviews;